import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface ImagePaperIconProps extends SvgIconProps {}

export const ImagePaperIcon = (props: ImagePaperIconProps): ReactElement => {
  return (
    <SvgIcon style={{ fontSize: '1em' }} {...props} viewBox="0 0 19.99 22.846">
      <path
        d="M21.633,21.918H7.354V19.062l4.284-7.139,5.868,7.139,4.127-2.856Zm0-9.281A2.142,2.142,0,1,1,19.491,10.5,2.142,2.142,0,0,1,21.633,12.637Zm1.914-5.6A20.23,20.23,0,0,0,21.6,4.814a20.235,20.235,0,0,0-2.224-1.945,3.559,3.559,0,0,0-2.029-.941H6.284A1.787,1.787,0,0,0,4.5,3.713V22.989a1.787,1.787,0,0,0,1.785,1.785H22.7a1.787,1.787,0,0,0,1.785-1.785V9.067a3.558,3.558,0,0,0-.941-2.029ZM20.593,5.824a19.474,19.474,0,0,1,1.619,1.815H18.777V4.2a19.454,19.454,0,0,1,1.815,1.619Zm2.468,17.165a.362.362,0,0,1-.357.357H6.284a.362.362,0,0,1-.357-.357V3.713a.362.362,0,0,1,.357-.357H17.349v5a.714.714,0,0,0,.714.714h5Z"
        transform="translate(-4.499 -1.928)"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
